import React from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import Card from '../../../../ui/Card';
import { PropertyManagerModule } from '../../PropertyManagerModule';

export const PropertyManagerSection = () => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails?.currentListing);

  if (!listing) return null;

  const { trusted, details, displayName, address } = listing;
  const hasManagerName = displayName && displayName !== address?.street;
  const hasContent = hasManagerName || trusted || details?.contactTimes;

  if (!hasContent) return null;

  return (
    <section>
      <Card variant="default" size="md" title="The property manager">
        <PropertyManagerModule />
      </Card>
    </section>
  );
};
